import { get, post, put } from './http-calls';

export const getBrakeTest_GetDetails = async (id, technicianJobId) => {
    let res = await get(`BrakeTest/BrakeTest_GetDetails?HeaderRecordID=${id}`, { useAuthToken: true });
    return res;
};

export const postBreakTestDetails = async (DocumentQCItemID, data) => {
    let res = await post(`BrakeTest/SignBrakeTest/${DocumentQCItemID}`, data, { useAuthToken: true });
    return res;
};
